import 'src/components/atoms/separator/index.scss';
import React from 'react';

export default () => ( <div className='separator' /> );
